import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Edit from '@material-ui/icons/Edit';
import Fab from '@material-ui/core/Fab';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { openLeftBarModule } from '../../modules/actions/layout';

import {
  makeGetAdministratorCompanies,
  makeGetASLCompanies,
  makeGetDefaultCompany,
  makeGetDriverCompanies,
  makeGetSubcontractorCompanies,
} from './selectors';

import './ApiUserRow.scss';

const ApiUserRow = ({
  user,
  administratorCompanies, aslCompanies, defaultCompany, driverCompanies, subcontractorCompanies,
  openLeftBarModule,
}) => (
  <TableRow>
    <TableCell>
      {`${user.attributes['first-name']} ${user.attributes['last-name']}`}
    </TableCell>

    <TableCell>
      {user.attributes['phone']}
      <br />
      {user.attributes['email']}
    </TableCell>

    <TableCell>
      {defaultCompany ? defaultCompany.attributes.name : <em>Onbekend</em>}
    </TableCell>

    <TableCell>
      {user.attributes['is-superuser'] && (
        <div className="apiuser-apiuserrow-role-list">
          <span>Beheerder</span>
        </div>
      )}

      {(administratorCompanies.length > 0) ? (
        <div className="apiuser-apiuserrow-role-list">
          <span>Wachtdienstmedewerker:</span>

          <ul>
            {administratorCompanies.map(company => (
              <li key={`administrator-${company.id}`}>
                {company.attributes.name}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {(aslCompanies.length > 0) ? (
        <div className="apiuser-apiuserrow-role-list">
          <span>ASL/Klantenservice:</span>

          <ul>
            {aslCompanies.map(company => (
              <li key={`asl-${company.id}`}>
                {company.attributes.name}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {(subcontractorCompanies.length > 0) ? (
        <div className="apiuser-apiuserrow-role-list">
          <span>Onderaannemer:</span>

          <ul>
            {subcontractorCompanies.map(company => (
              <li key={`subcontractor-${company.id}`}>
                {company.attributes.name}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {(driverCompanies.length > 0) ? (
        <div className="apiuser-apiuserrow-role-list">
          <span>Chauffeur:</span>

          <ul className="apiuser-apiuserrow-role-list">
            {driverCompanies.map(company => (
              <li key={`driver-${company.id}`}>
                {company.attributes.name}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </TableCell>

    <TableCell>
      <div onClick={() => openLeftBarModule('apiUser', 'apiUserEdit', { id: user.id })}>
        <Fab color="primary" aria-label="edit" size="small">
          <Edit />
        </Fab>
      </div>
    </TableCell>
  </TableRow>
);

const CompanyPropShape = PropTypes.shape({
  id: PropTypes.string.isRequired,

  attributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
});

ApiUserRow.propTypes = {
  // own props
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,

    attributes: PropTypes.shape({
      email: PropTypes.string.isRequired,
      'first-name': PropTypes.string.isRequired,
      'is-superuser': PropTypes.bool,
      'last-name': PropTypes.string.isRequired,
      'phone': PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,

  // state props
  administratorCompanies: PropTypes.arrayOf(CompanyPropShape).isRequired,
  aslCompanies: PropTypes.arrayOf(CompanyPropShape).isRequired,
  defaultCompany: CompanyPropShape,
  driverCompanies: PropTypes.arrayOf(CompanyPropShape).isRequired,
  subcontractorCompanies: PropTypes.arrayOf(CompanyPropShape).isRequired,

  // dispatch props
  openLeftBarModule: PropTypes.func.isRequired,
};

ApiUserRow.defaultProps = {
  defaultCompany: undefined,
};

const makeMapStateToProps = () => {
  const getAdministratorCompanies = makeGetAdministratorCompanies();
  const getASLCompanies = makeGetASLCompanies();
  const getDefaultCompany = makeGetDefaultCompany();
  const getDriverCompanies = makeGetDriverCompanies();
  const getSubcontractorCompanies = makeGetSubcontractorCompanies();

  return (state, ownProps) => ({
    administratorCompanies: getAdministratorCompanies(state, ownProps),
    aslCompanies: getASLCompanies(state, ownProps),
    defaultCompany: getDefaultCompany(state, ownProps),
    driverCompanies: getDriverCompanies(state, ownProps),
    subcontractorCompanies: getSubcontractorCompanies(state, ownProps),
  });
};

export default connect(makeMapStateToProps, { openLeftBarModule })(ApiUserRow);
